import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

export const CCheck = () => {
  const { t } = useLanguage();
  return (
    <section id="ccheck" data-testid="ccheck-section" className="py-28 md:py-36 border-t border-white/10 bg-[#0F172A]/40">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-mono-tech text-xs tracking-[0.25em] uppercase text-[#60A5FA] mb-6" data-testid="ccheck-overline">
            {t.ccheck.overline}
          </p>
          <h2 className="font-display font-bold tracking-tight leading-[1.05] text-4xl md:text-5xl" data-testid="ccheck-title">
            {t.ccheck.title}
          </h2>
          <p className="mt-7 text-slate-300 text-base md:text-lg leading-relaxed" data-testid="ccheck-body">
            {t.ccheck.body}
          </p>
          <ul className="mt-8 space-y-3">
            {t.ccheck.stats.map((s, i) => (
              <li key={i} className="flex items-center gap-3 text-slate-200" data-testid={`ccheck-stat-${i}`}>
                <CheckCircle2 size={18} className="text-[#2563EB] shrink-0" />
                <span className="text-sm md:text-base">{s}</span>
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15 }}
        >
          <div className="relative overflow-hidden rounded-2xl border border-white/10 shadow-2xl shadow-[#2563EB]/10">
            <iframe
              data-testid="ccheck-video"
              src="https://www.youtube-nocookie.com/embed/37xMgLzYMlo"
              title={t.ccheck.videoLabel}
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="w-full aspect-video"
            />
          </div>
          <p className="mt-4 font-mono-tech text-xs tracking-widest uppercase text-slate-500" data-testid="ccheck-video-label">
            {t.ccheck.videoLabel}
          </p>
        </motion.div>
      </div>
    </section>
  );
};
